import classNames from 'classnames'
import {memo} from 'react'

import type {TestOccurrenceId} from '../../../../../../../../types'
import BuildPathAndStatus from '../../../../../../../common/BuildPathAndStatus/BuildPathAndStatus'
import {
  getTestOccurrence,
  getTestOccurrenceNewFailure,
  getTestOccurrenceNextFixed,
} from '../../../../../../../packages/Tests/Tests.selectors'
import {TestStatus} from '../../../../../../../packages/Tests/Tests.types'

import styles from './TestRunBuildPath.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  testOccurrenceId?: TestOccurrenceId
}

function TestRunBuildPath({testOccurrenceId}: Props) {
  const testOccurrence = useAppSelector(state => getTestOccurrence(state, testOccurrenceId))
  const newFailure = useAppSelector(state => getTestOccurrenceNewFailure(state, testOccurrenceId))
  const nextFixed = useAppSelector(state => getTestOccurrenceNextFixed(state, testOccurrenceId))
  const {build, status, muted} = testOccurrence ?? {}
  const testBuildId = build?.id
  const testBuildTypeId = build?.buildTypeId
  return (
    <BuildPathAndStatus
      className={classNames({
        [styles.newTest]: newFailure === true && status === TestStatus.FAILURE && !muted,
        [styles.fixedTest]: nextFixed != null,
      })}
      entityPathClassName={styles.entityPath}
      buildStatusClassName={styles.buildStatus}
      linkClassName={styles.entityPathLink}
      buildTypeId={testBuildTypeId}
      buildId={testBuildId}
      withLeafStatusIcon={false}
      withCollapsing
    />
  )
}

export default memo<Props>(TestRunBuildPath)
